import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import LogoPath from '@/public/images/Logo.png';

const Header: React.FC<any> = () => {
  const clickHandler = () => {
    location.href = 'https://ooia5293gn.jobs.feishu.cn/index/position/list';
  };

  return (
    <header className={`${styles.mj_header_container}`}>
      <div className={styles.mj_header_container_left}>
        <Image
          className={styles.mj_header_Logo}
          width={137}
          height={47}
          src={LogoPath}
          alt="Manjuu"
        />
        <div className={styles.mj_header_container_title}>蛮啾网络招聘官网</div>
      </div>
      <div className={styles.mj_header_container_right}>
        <div onClick={clickHandler}>社会招聘</div>
        <div>|</div>
        <div
          onClick={() => {
            location.href = 'https://ooia5293gn.jobs.feishu.cn/campus';
          }}>
          校园招聘
        </div>
      </div>
    </header>
  );
};

export default Header;
